globalThis.Time = class Time {
  constructor(ms) {
    this.value = ms;
  }

  toString() {
    const hours = this.getHours().toString().padStart(2, "0");
    const minutes = this.getMinutes().toString().padStart(2, "0");
    const seconds = this.getSeconds().toString().padStart(2, "0");
    const millis = this.getMillis().toString().padStart(3, "0");
    return `${hours}:${minutes}:${seconds}.${millis}`;
  }

  getMillis() {
    return this.value % 1000;
  }

  getSeconds() {
    return Math.floor(this.value / 1000) % 60;
  }

  getMinutes() {
    return Math.floor(this.value / 1000 / 60) % 60;
  }

  getHours() {
    return Math.floor(this.value / 1000 / 60 / 60) % 24;
  }
};
